import { useQuery } from "@tanstack/react-query";

import { LocationActivityQueryParams } from "../../../components/LocationActivityComponents/LocationActivityTable/types";
import DataSvc from "../../../services/dataSvc";

const useLocationsActivity = (queryParams: LocationActivityQueryParams) => {
  const query = useQuery({
    queryKey: ["locationsActivity", queryParams],
    queryFn: () => DataSvc.getLocationsActivity(queryParams)
  });

  return query;
};

export default useLocationsActivity;
